import React from 'react';
import { Space } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import {
  DetailCard,
  DetailCardHeader,
  DetailCardTitleSection,
  DetailCardTitle,
  DetailCardSubtitle,
  DetailCardCloseButton,
  DetailCardCloseIconWrapper,
  OverviewContent,
  OverviewValue,
  OverviewLabel,
} from './Styles';

interface SessionsOverviewProps {
  sessionCount: number;
  onClose: () => void;
}

const SessionsOverview: React.FC<SessionsOverviewProps> = ({
  sessionCount,
  onClose,
}) => {
  return (
    <DetailCard
      title={
        <DetailCardHeader>
          <DetailCardTitleSection>
            <DetailCardTitle>Current Sessions Overview</DetailCardTitle>
            <DetailCardSubtitle>Overview of all current sessions</DetailCardSubtitle>
          </DetailCardTitleSection>
          <DetailCardCloseButton onClick={onClose}>
            <DetailCardCloseIconWrapper>
              <FontAwesomeIcon icon={faTimes} />
            </DetailCardCloseIconWrapper>
          </DetailCardCloseButton>
        </DetailCardHeader>
      }
    >
      <Space direction="vertical" size="large">
        <OverviewContent>
          <div>
            <OverviewValue>{sessionCount}</OverviewValue>
            <OverviewLabel>Active Sessions</OverviewLabel>
          </div>
        </OverviewContent>
      </Space>
    </DetailCard>
  );
};

export default SessionsOverview;